module.exports = __webpack_public_path__ + "img/pic_7.a8491a1d.png";